/**
 * Error Message Constants
 * 
 * Centralized error messages to avoid duplication across the codebase.
 * These messages are used consistently throughout the application.
 * 
 * @module errorMessages
 */

export const ERROR_MESSAGES = {
  NETWORK_ERROR: 'Network error. Please check your connection.',
  NETWORK_ERROR_DETAILED: 'Network error. Please check your internet connection.',
  TIMEOUT_ERROR: 'Request timeout. Please try again.',
  UNEXPECTED_ERROR: 'An unexpected error occurred.',
  DEFAULT_ERROR: 'An error occurred'
};

export default ERROR_MESSAGES;

